import "@telekom-ods/react-ui-kit/style.css";
import { Reset, ThemeProvider } from 'dt-components';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Router } from 'react-router-dom';
import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';
import history from './utils/history';


const container = document.getElementById('root')!;
const root = createRoot(container);

const renderApp = () => {
    root.render(
    <ThemeProvider theme={{}}>
        <BrowserRouter>
        {/* <Provider store={store}> */}
        <Router history={history}>
            <Reset />
            <App />
        </Router>
        {/* </Provider> */}
        </BrowserRouter>
    </ThemeProvider>);
}

renderApp();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
